import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetchData } from "./UseStudentGetApi";
import { apiUrlShop } from "../../shared/constants";



export const useProductList = (filters = {}) => {
  return useInfiniteQuery({
    queryKey: ["allproducts", filters],
    queryFn: async ({ pageParam = 1 }) => {
      return await fetchData("allproducts", { ...filters, page: pageParam }, apiUrlShop);
    },
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage?.pagination?.currentPage || 1;
      const totalPages = lastPage?.pagination?.totalPages || 1;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });
};


export const useGetLMSDetail = (id) => {
  return useQuery({
    queryKey: ["lms/content"],
    queryFn: () => fetchData(`lms/${id}/content`),

  });
};